import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { serverURL } from "../components/networking";
import korotuLogo from "../resources/KorotuLogo.png";

const SHOW_LOGIN = 0;
const SHOW_REGISTER = 1;
const SHOW_RESET = 2;

export default function LoginPage() {
    const [register, setRegister] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(serverURL + "/api/check-web-session/", {
                withCredentials: true,
            })
            .then(function (response) {
                if (response.data.isAuthenticated) {
                    sessionStorage.setItem("user_id", response.data.user_id);
                    navigate("/home");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }, [navigate]);

    return (
        <div className="login-page">
            <div className="login-left">
                <div className="login-brand">
                    <img src={korotuLogo} alt="Korotu logo" />
                </div>
            </div>

            <div className="login-right">
                {register === SHOW_LOGIN ? (
                    <LoginForm
                        setRegister={setRegister}
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                        errorMessage={errorMessage}
                    />
                ) : register === SHOW_REGISTER ? (
                    <RegisterForm
                        setRegister={setRegister}
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                        errorMessage={errorMessage}
                    />
                ) : (
                    <ForgotPasswordForm
                        setRegister={setRegister}
                        navigate={navigate}
                        setErrorMessage={setErrorMessage}
                        errorMessage={errorMessage}
                    />
                )}
            </div>
        </div>
    );
}

function RegisterForm({
    setRegister,
    navigate,
    setErrorMessage,
    errorMessage,
}) {
    const [email, setEmail] = useState("");

    function register(email) {
        let csrf = document.cookie.replace(
            /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
        );

        axios
            .post(
                serverURL + "/api/user/register/",
                { email: email },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                console.log(response);
                if (response.status === 200) {
                    navigate("/confirm", { state: { email: email } });
                    setErrorMessage("Successfully registered!");
                }
            })
            .catch(function (error) {
                console.log(error);
                setErrorMessage(error.message);
            });
    }

    return (
        <div className="login-card">
            <h2>Sign up for CarbonCruise</h2>
            <div className="login-field">
                <label htmlFor="register-email">Email</label>
                <input
                    id="register-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <button type="button" onClick={() => register(email)}>
                Register
            </button>
            <button
                type="button"
                className="login-secondary"
                onClick={() => {
                    setErrorMessage("");
                    setRegister(SHOW_LOGIN);
                }}
            >
                Return to Sign In
            </button>
            {errorMessage ? (
                <p className="error-message" role="alert">
                    {errorMessage}
                </p>
            ) : null}
        </div>
    );
}

function LoginForm({ setRegister, navigate, setErrorMessage, errorMessage }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    function login(email, password) {
        let csrf = document.cookie.replace(
            /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
        );
        setErrorMessage("");
        axios
            .post(
                serverURL + "/api/user/login/",
                { email: email, password: password },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                sessionStorage.setItem("user_id", response.data.user.user_id);
                console.log(response.data);
                localStorage.setItem("email", response.data.user.email);
                localStorage.setItem("username", response.data.user.username);
                localStorage.setItem(
                    "subscription",
                    response.data.user.subscription,
                );
                console.log(typeof response.data.user.subscription);
                console.log(
                    `Updated localStorage: ${localStorage.getItem("email")}, ${localStorage.getItem("username")}, ${localStorage.getItem("subscription")}`,
                );
                navigate("/home");
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setErrorMessage(
                    error.response
                        ? error.response.data.message
                        : "An unexpected error occurred",
                );
            });
    }

    return (
        <div className="login-card">
            <h2>Sign Into CarbonCruise</h2>
            <div className="login-field">
                <label htmlFor="login-email">Email</label>
                <input
                    id="login-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div className="login-field">
                <label htmlFor="login-password">Password</label>
                <input
                    id="login-password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <button type="button" onClick={() => login(email, password)}>
                Log In
            </button>
            <button
                type="button"
                className="login-secondary"
                onClick={() => {
                    setErrorMessage("");
                    setRegister(SHOW_RESET);
                }}
            >
                Forgot Password
            </button>
            <div className="login-divider" />
            <div className="signup-block">
                <p>Don&apos;t have an account?</p>
                <button
                    type="button"
                    className="login-inline"
                    onClick={() => {
                        setErrorMessage("");
                        setRegister(SHOW_REGISTER);
                    }}
                >
                    Sign Up
                </button>
            </div>
            {errorMessage ? (
                <p className="error-message" role="alert">
                    {errorMessage}
                </p>
            ) : null}
        </div>
    );
}

function ForgotPasswordForm({
    setRegister,
    navigate,
    setErrorMessage,
    errorMessage,
}) {
    const [email, setEmail] = useState("");

    function requestPasswordReset(email) {
        if (email !== "") {
            let csrf = document.cookie.replace(
                /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
                "$1",
            );
            setErrorMessage("");
            axios
                .post(
                    serverURL + "/api/user/request-password-reset/",
                    { email: email },
                    {
                        withCredentials: true,
                        headers: {
                            "X-CSRFToken": csrf,
                        },
                    },
                )
                .then(function (response) {
                    console.log(response);
                    setErrorMessage(
                        "If an account is associated with this email, instructions to reset password will be sent.",
                    );
                    navigate("/reset", { state: { email: email } });
                })
                .catch(function (error) {
                    console.log(error);
                    console.log(error.response);
                    setErrorMessage(error.response.data.message);
                });
        } else {
            setErrorMessage("Email field cannot be blank.");
        }
    }

    return (
        <div className="login-card">
            <h2>Forgot Password?</h2>
            <p className="login-helper">
                Enter your email address to receive instructions on how to reset
                your password
            </p>
            <div className="login-field">
                <label htmlFor="reset-email">Email</label>
                <input
                    id="reset-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <button type="button" onClick={() => requestPasswordReset(email)}>
                Submit
            </button>
            <button
                type="button"
                className="login-secondary"
                onClick={() => {
                    setErrorMessage("");
                    setRegister(SHOW_LOGIN);
                }}
            >
                Return to Sign In
            </button>
            {errorMessage ? (
                <p className="error-message" role="alert">
                    {errorMessage}
                </p>
            ) : null}
        </div>
    );
}
